import { useEffect, useState } from "react";
import MultiModal from "../../components/shared/MultiModal/MultiModal";
import MultiModalSection from "../../components/shared/MultiModal/MultiModalSection";
import { ClipboardDocumentIcon, CodeBracketIcon } from "@heroicons/react/24/outline";
import { Button } from "../../components/base/Button";
import useNotification from "../../components/shared/Notifications/useNotifications";



export default function EmbedShopify({ customerId }: { customerId?: string }) {
  const { addNotification } = useNotification();
  
  const [open, setOpen] = useState(false);

  const [sectionTemplate, setSectionTemplate] = useState<string>("");
  const [withTemplate   , setWithTemplate   ] = useState<string>("");
  const [withoutTemplate, setWithoutTemplate] = useState<string>("");

  useEffect(() => {
    fetch("/templates/ymm-search-section.liquid")
      .then((r) => r.text())
      .then((text) => setSectionTemplate(text.replaceAll("{{ customer_id }}", customerId ?? "00000000-0000-0000-0000-000000000000")));

    fetch("/templates/ymm-search-with-vrm.liquid")
      .then((r) => r.text())
      .then(setWithTemplate);

    fetch("/templates/ymm-search-without-vrm.liquid")
      .then((r) => r.text())
      .then(setWithoutTemplate);
  }, [customerId]);

  const copy = async (template: any) => {
    await navigator.clipboard.writeText(template);

    addNotification({
      variant: "success",
      primaryText: `Copied to clipboard`,
    });
  };

  return (
    <>
      <Button className="flex items-center space-x-2" onClick={() => setOpen(true)}>
        <CodeBracketIcon className="h-5 w-5 -ml-1" />
        <p>Shopify Embed</p>
      </Button>

      <MultiModal isOpen={open} onClose={setOpen} cols="sm:grid-cols-3">
        <MultiModalSection title="sections/ymm-search.liquid">
          <p className="my-2">
            Copy this and add it to the sections folder in your Shopify theme
          </p>

          <div style={{ display: "grid", gap: 8 }} className="mt-2 max-h-[400px] overflow-auto relative rounded-lg border border-gray-300 bg-gray-50 p-2">

            <pre style={{ margin: 0, padding: 12, overflow: "auto" }}>
              <code>{sectionTemplate}</code>
            </pre>
            
            
          </div>
          <Button className="w-full flex items-center space-x-2 mt-2" onClick={() => copy(sectionTemplate)}>
            <ClipboardDocumentIcon className="h-5 w-5 -ml-1" />
            <p>Copy</p>
          </Button>
        </MultiModalSection>

        <MultiModalSection title="snippets/ymm-search.liquid (with VRM Lookup)">
          <p className="my-2">
            Copy this and add it to the snippets folder in your Shopify theme
          </p>

          <div style={{ display: "grid", gap: 8 }} className="mt-2 max-h-[400px] overflow-auto relative rounded-lg border border-gray-300 bg-gray-50 p-2">

            <pre style={{ margin: 0, padding: 12, overflow: "auto" }}>
              <code>{withTemplate}</code>
            </pre>
            
            
          </div>
          <Button className="w-full flex items-center space-x-2 mt-2" onClick={() => copy(withTemplate)}>
            <ClipboardDocumentIcon className="h-5 w-5 -ml-1" />
            <p>Copy</p>
          </Button>
        </MultiModalSection>

        <MultiModalSection title="snippets/ymm-search.liquid (without VRM Lookup)">
          <p className="my-2">
            Copy this and add it to the snippets folder in your Shopify theme
          </p>

          <div style={{ display: "grid", gap: 8 }} className="mt-2 max-h-[400px] overflow-auto relative rounded-lg border border-gray-300 bg-gray-50 p-2">

            <pre style={{ margin: 0, padding: 12, overflow: "auto" }}>
              <code>{withoutTemplate}</code>
            </pre>

          </div>
          <Button className="w-full flex items-center space-x-2 mt-2" onClick={() => copy(withoutTemplate)}>
            <ClipboardDocumentIcon className="h-5 w-5 -ml-1" />
            <p>Copy</p>
          </Button>
        </MultiModalSection>
      </MultiModal>
    </>
  )
}